import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-offwhite pb-20 px-6" data-id="element-186">
      <div className="max-w-3xl mx-auto" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-188">
          <h3 className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-6" data-id="element-189">
            El Verdadero Problema
          </h3>

          <div className="space-y-6 text-lg text-slate-800 leading-relaxed" data-id="element-190">
            <p data-id="element-191">
              El problema no es el mensaje de tu ex. El problema es que le diste
              la{' '}
              <strong className="text-slate-900 font-bold bg-amber-100 px-1" data-id="element-192">
                "llave maestra" de tu tranquilidad
              </strong>{' '}
              las 24 horas del día. Cada vez que respondés desde la herida, cada
              vez que intentás "explicar" tu punto de vista o justificar por qué
              hiciste lo que hiciste, estás mordiendo el anzuelo.
            </p>

            <p data-id="element-193">
              Esa energía que gastás tipeando testamentos de odio es{' '}
              <strong className="text-slate-900 font-bold" data-id="element-194">
                energía que le robás a tus hijos
              </strong>
              . Ellos te necesitan presente, no con los ojos inyectados en
              sangre mirando una pantalla mientras ellos juegan solos.
            </p>

            <div className="bg-slate-100 p-6 rounded-xl border border-slate-200 mt-8" data-id="element-195">
              <p className="text-xl font-playfair font-bold text-slate-900 text-center" data-id="element-196">
                El conflicto se alimenta de tu reacción. Si no hay reacción, el
                fuego se apaga.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}